/**
 * useReferralCampaign Hook
 *
 * Fetches and manages Referral campaign status for VIP referral codes.
 * Returns campaign details including:
 * - Whether user is eligible (bound to VIP referral code)
 * - User's bonus points earned
 * - Remaining bonus available
 * - Bound referral code
 */

import { useQuery } from '@tanstack/react-query';

import { getReferralCampaignStatus } from '@/api/auth';

export function useReferralCampaign() {
  const query = useQuery({
    queryKey: ['referralCampaign'],
    queryFn: async () => {
      const response = await getReferralCampaignStatus();
      if (response.code !== 0) {
        throw new Error(response.message || 'Failed to fetch referral campaign status');
      }
      return response.data;
    },
    staleTime: 30 * 1000, // Cache for 30 seconds
    refetchInterval: 60 * 1000, // Refetch every 60 seconds
  });

  return {
    campaignData: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
